import * as SentryReact from "@sentry/react";

const isProduction = process.env.NODE_ENV === "production";

if (isProduction) {
  SentryReact.init({
    dsn: "https://4263f4b2ac327ddc3d7f243263c2ab7f@o4508755265781760.ingest.de.sentry.io/4510334902337616",
    integrations: [],
    // Noise from in-app browsers (Facebook/Instagram) and browser extensions.
    ignoreErrors: [/Java object is gone/, /runtime\.sendMessage/],
    denyUrls: [/^iabjs:\/\//, /^(chrome|moz|safari(-web)?)-extension:\/\//],
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    //tracePropagationTargets: [/^\//, /^https:\/\/(.+)?.e-fork\.net\/graphql/],
  });
}
